import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Grid, Skeleton, Typography } from "@mui/material"
import PaperBox from "components/PaperBox"
import theme from "css/theme/light"
import { allRoutes } from "generated/routes"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import { IExamSummaryCard } from "../interface/admin.interface"

const ExamOverviewCard = (props: IExamSummaryCard) => {
  const {
    id,
    examinationName,
    icon,
    subtitle1,
    subtitle2,
    subtitle3,
    attendeesCount,
    passedCount,
    expiresIn30Days,
    expiredCount
  } = props

  const { t } = useTranslation("translation", { keyPrefix: "learning.admin.overview" })
  console.log("examinationName", examinationName)
  return (
    <PaperBox mt={0} {...props}>
      <Grid
        alignItems="center"
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
        item
        sx={{
          flexWrap: { xs: "wrap", md: "nowrap" },

          maxWidth: "100%"
        }}>
        <Grid container display="flex" flexWrap="wrap">
          <Grid item>
            <Typography variant="h4" fontWeight="400" mb={1}>
              {t(examinationName)}
            </Typography>
            <Typography variant="bodySmall" color="text.secondary">
              {attendeesCount}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        display="flex"
        spacing={2}
        sx={{
          flexDirection: { xs: "row", md: "row", lg: "row" },
          justifyContent: { xs: "space-between" }
        }}
        mt={2}
        mb={4}>
        <Grid item>
          <Typography variant="bodyMedium">{subtitle1}</Typography>
          {passedCount !== null ? (
            <Typography fontWeight={600} variant="bodyMedium">
              {passedCount}
            </Typography>
          ) : (
            <Typography variant="bodySmall" color="textSecondary">
              <Skeleton />
            </Typography>
          )}
        </Grid>
        <Grid item>
          <Typography variant="bodyMedium">{subtitle2}</Typography>
          {expiresIn30Days !== null ? (
            <Typography fontWeight={600} variant="bodyMedium">
              {expiresIn30Days}
            </Typography>
          ) : (
            <Typography variant="bodySmall" color="textSecondary">
              <Skeleton />
            </Typography>
          )}
        </Grid>
        <Grid item>
          <Typography variant="bodyMedium">{subtitle3}</Typography>
          {expiredCount !== null ? (
            <Typography fontWeight={600} variant="bodyMedium">
              {expiredCount}
            </Typography>
          ) : (
            <Typography variant="bodySmall" color="textSecondary">
              <Skeleton />
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid
        item
        direction="row"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        spacing={3}>
        <Grid item></Grid>
        <Grid item>
          <Button
            component={NavLink}
            to={allRoutes.LearningAdminExamsDetails(id)}
            variant="contained"
            color="primary">
            {t(`buttons.administer`, "Administer")}
          </Button>
        </Grid>
      </Grid>
    </PaperBox>
  )
}

export default ExamOverviewCard
